import { HelpCircle } from 'lucide-react';
import { Popover, PopoverTrigger, PopoverContent } from '../ui/popover';

const BAR_INFO = {
  lb: [['45', 'Standard Olympic barbell (the long gym bar)'], ['35', "Women's Olympic bar (a bit shorter and thinner)"], ['EZ 15', 'Short zig-zag curl bar']],
  kg: [['20', 'Standard Olympic barbell (the long gym bar)'], ['15', "Women's Olympic bar (a bit shorter and thinner)"], ['EZ 10', 'Short zig-zag curl bar']],
};

export const PlateHelp = ({ unit, example }) => (
  <Popover>
    <PopoverTrigger asChild>
      <button type="button" aria-label="How the plate calculator works" className="text-white/40 hover:text-primary transition-colors" data-testid="plate-help-btn">
        <HelpCircle className="h-4 w-4" />
      </button>
    </PopoverTrigger>
    <PopoverContent align="start" className="w-72 bg-card border border-primary/40 rounded-2xl p-4 text-xs text-white/80 space-y-2" data-testid="plate-help-popover">
      <p className="font-heading text-sm uppercase tracking-wider text-white">How it works</p>
      <p>Pick the bar you're using. We subtract its weight from your total, then split the rest evenly between both sides.</p>
      <ul className="space-y-1">
        {BAR_INFO[unit].map(([label, text]) => (
          <li key={label}><b className="text-primary">{label}</b>: {text}</li>
        ))}
      </ul>
      <p className="text-white/60">{example}</p>
      <p className="text-white/50">If a weight can't be loaded exactly, we show the closest one you can. Your bar choice is saved on this device.</p>
    </PopoverContent>
  </Popover>
);

export default PlateHelp;
